import clsx from 'clsx';
import Structure from 'components/3cat/Structure';
import { useProducte } from 'hooks/3cat/useProducte';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import __isEmpty from 'lodash/isEmpty';
import styles from './tabcustom.module.scss';

export default function TabsCustom(props) {
    const { activeTab, estil } = props;
    const [activeTabWebview, setActiveTabWebview] = useState(activeTab);
    const { isWebviewActive } = useProducte();

    const ancestorProps = { activeTabWebview, setActiveTabWebview };

    const router = useRouter();

    const stylesTabsCustom = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [styles.webview]: isWebviewActive
    });

    useEffect(() => {
        if (router.query['seccio'] !== undefined) {
            setActiveTabWebview(router.query['seccio']);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={stylesTabsCustom}>
            <Structure {...props} ancestorProps={ancestorProps} />
        </div>
    );
}
